"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
const styles_1 = require("@material-ui/core/styles");
const FormControlLabel_1 = __importDefault(require("../FormControlLabel"));
const styles_2 = __importDefault(require("./styles"));
const FallbackIcon = () => null;
exports.Radio = (_a) => {
    var _b = _a.classes, { root, icon, label: labelClass } = _b, otherClasses = __rest(_b, ["root", "icon", "label"]), { className, style, label, checked, disabled, value, onChange } = _a;
    const radioProps = {
        checked,
        disabled,
        onChange,
        value,
        checkedIcon: react_1.default.createElement(FallbackIcon, null),
        icon: react_1.default.createElement(FallbackIcon, null),
        color: 'default',
        classes: Object.assign({}, otherClasses, { root: classnames_1.default(root, icon) })
    };
    return label ? (react_1.default.createElement(FormControlLabel_1.default
    // eslint-disable-next-line react/jsx-props-no-spreading
    , { 
        // eslint-disable-next-line react/jsx-props-no-spreading
        control: react_1.default.createElement(Radio_1.default, Object.assign({}, radioProps)), classes: {
            root: labelClass
        }, className: className, style: style, label: label })) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(Radio_1.default, Object.assign({}, radioProps, { className: className, style: style })));
};
exports.Radio.defaultProps = {
    checked: undefined,
    classes: {},
    disabled: false,
    label: undefined,
    value: undefined
};
exports.Radio.displayName = 'Radio';
exports.Radio.Group = RadioGroup_1.default;
exports.default = styles_1.withStyles(styles_2.default)(exports.Radio);
//# sourceMappingURL=Radio.js.map